import { useI18n } from "@/context/I18nContext";

function computeMood(summary) {
  const tm = summary?.this_month || {};
  const spent = (tm.expense || 0) + (tm.recurring || 0);
  const earned = (tm.income || 0) + (tm.revenue || 0);
  if (!earned && !spent) return { emoji: "neutral", pct: 0 };
  if (!earned) return { emoji: "sad", pct: 0 };
  const raw = ((earned - spent) / earned) * 100;
  // Never surface a negative savings ratio — clamp visually at 0, but still show sad mood if overspent.
  const pct = Math.max(0, Math.round(raw));
  const emoji = raw >= 20 ? "happy" : raw >= 0 ? "neutral" : "sad";
  return { emoji, pct };
}

const FACES = {
  happy: { mouth: "M42 62 Q60 82 78 62", eye: "closed" },
  neutral: { mouth: "M42 68 L78 68", eye: "open" },
  sad: { mouth: "M42 74 Q60 58 78 74", eye: "open" },
};

export function NeuMood({ summary }) {
  const { lang } = useI18n();
  const { emoji, pct } = computeMood(summary);
  const face = FACES[emoji];
  const label = lang === "ar"
    ? (emoji === "happy" ? "توفير رائع" : emoji === "neutral" ? "متوازن" : "تجاوز الميزانية")
    : (emoji === "happy" ? "great savings" : emoji === "neutral" ? "balanced" : "overspent");
  const moodColor = emoji === "happy" ? "#16a34a" : emoji === "neutral" ? "#64748b" : "#dc2626";
  return (
    <div className="neu p-6 h-full flex items-center gap-4">
      <div className="flex-1 min-w-0 space-y-1">
        <p className="font-display text-lg font-bold neu-accent-blue leading-tight">{lang === "ar" ? "نسبة الادخار من الدخل" : "Savings ratio of income"}</p>
        <p className="font-display text-xl sm:text-2xl font-extrabold truncate" style={{ color: moodColor }}>{label}</p>
        <p className="text-sm font-semibold tabular-nums" style={{ color: moodColor }}>{pct}%</p>
      </div>
      <svg viewBox="0 0 120 120" className="w-24 h-24 shrink-0 neu-inset rounded-full p-3">
        {face.eye === "open" ? (
          <>
            <circle cx="45" cy="48" r="5" fill="#f5b800" />
            <circle cx="75" cy="48" r="5" fill="#f5b800" />
          </>
        ) : (
          <>
            <path d="M38 48 Q45 42 52 48" stroke="#f5b800" strokeWidth="4" fill="none" strokeLinecap="round" />
            <path d="M68 48 Q75 42 82 48" stroke="#f5b800" strokeWidth="4" fill="none" strokeLinecap="round" />
          </>
        )}
        <path d={face.mouth} stroke="#f5b800" strokeWidth="4" fill="none" strokeLinecap="round" />
      </svg>
    </div>
  );
}
